
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/Layout';
import { QRCodeGenerator } from './components/QRCodeGenerator';
import { SEO } from './components/SEO';
import { LANGUAGES } from './constants';

const QRCodeScanner = React.lazy(async () => {
  const mod = await import('./components/QRCodeScanner');
  return { default: mod.QRCodeScanner };
});

const BlogList = React.lazy(async () => {
  const mod = await import('./components/Blog');
  return { default: mod.BlogList };
});

const BlogPost = React.lazy(async () => {
  const mod = await import('./components/Blog');
  return { default: mod.BlogPost };
});

const HelpPage = React.lazy(async () => {
  const mod = await import('./components/InfoPages');
  return { default: mod.HelpPage };
});

const ContactPage = React.lazy(async () => {
  const mod = await import('./components/InfoPages');
  return { default: mod.ContactPage };
});

const PrivacyPage = React.lazy(async () => {
  const mod = await import('./components/InfoPages');
  return { default: mod.PrivacyPage };
});

const TermsPage = React.lazy(async () => {
  const mod = await import('./components/InfoPages');
  return { default: mod.TermsPage };
});

const getDefaultLang = () => {
  if (typeof navigator !== 'undefined' && navigator.language) {
    const full = navigator.language.toLowerCase();
    if (full in LANGUAGES) {
      return full as keyof typeof LANGUAGES;
    }
    const base = full.split('-')[0];
    const fallbackMatch = Object.keys(LANGUAGES).find((code) => code.startsWith(base));
    if (fallbackMatch) {
      return fallbackMatch;
    }
  }
  return 'en';
};

const RootRedirect: React.FC = () => {
  if (typeof window === 'undefined') return null;
  return <Navigate to={`/${getDefaultLang()}/qrcode-generator`} replace />;
};

const LanguageIndexRedirect: React.FC = () => {
  if (typeof window === 'undefined') return null;
  return <Navigate to="qrcode-generator" replace />;
};

function App() {
  return (
    <Routes>
      {/* Root Redirect */}
      <Route path="/" element={<RootRedirect />} />

      {/* Language Routes */}
      <Route path="/:lang" element={<><SEO /><Layout /></>}>
        <Route index element={<LanguageIndexRedirect />} />
        <Route path="qrcode-generator" element={<QRCodeGenerator variant="default" />} />
        <Route path="text-to-qrcode" element={<QRCodeGenerator variant="text-to" />} />
        <Route path="link-to-qrcode" element={<QRCodeGenerator variant="link-to" />} />
        <Route path="qrcode-scanner" element={<QRCodeScanner />} />
        {/* Legacy paths */}
        <Route path="generate" element={<Navigate to="../qrcode-generator" replace />} />
        <Route path="scan" element={<Navigate to="../qrcode-scanner" replace />} />
        <Route path="blog" element={<BlogList />} />
        <Route path="blog/:slug" element={<BlogPost />} />
        <Route path="help" element={<HelpPage />} />
        <Route path="contact" element={<ContactPage />} />
        <Route path="privacy" element={<PrivacyPage />} />
        <Route path="terms" element={<TermsPage />} />
      </Route>

      {/* Fallback */}
      <Route path="*" element={<RootRedirect />} />
    </Routes>
  );
}

export default App;
